import img_recruitment from "../../assets/images/img_recruitment.webp";
import ic_location from "../../assets/icons/ic_location.svg";
import ic_timer_pause from "../../assets/icons/ic_timer_pause.svg";
import { getLevelLabel, getPostionLabel } from "../../enums/recruitment";
import { Link } from "react-router-dom";
import { formatDate, getRangeSalary } from "./ultil";
import { Box } from "@mui/material";

export default function RecruitmentItem({ item, showImage = true }) {
  return (
    <Link
      to={`/recruitment/detail/${item.slug}/${item.id}`}
      className="rounded-lg flex relative border-[1px] overflow-hidden border-gray-300 hover:border-[#27C6FF] hover:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.12)] group"
      style={{ transition: "all 0.3s" }}
    >
      {item.isHot && (
        <div className="absolute text-white px-5 py-[6px] text-[14px] top-2 left-2 rounded-2xl bg-[#FF3F4F]">
          Hot
        </div>
      )}

      {showImage && (
        <img src={img_recruitment} className="w-[260px] hidden sm:block" />
      )}

      <Box
        className="px-4 py-5"
        sx={{ marginTop: showImage ? { xs: "32px", sm: "0px" } : "32px" }}
      >
        <p
          className="font-semibold line-clamp-2] group-hover:text-[#27C6FF] cursor-pointer"
          style={{ transition: "all 0.3s" }}
        >
          {item.title}
        </p>
        <div className="flex gap-4 mt-[6px]">
          <p>{getPostionLabel(item.position)}</p>
          <p>•</p>
          <p>{getLevelLabel(item.level)}</p>
        </div>
        <p className="font-semibold mt-2 text-[#1C9BDB] text-[18px]">
          {getRangeSalary(
            item?.startSalary.toString(),
            item?.endSalary.toString(),
            item?.salaryLevel
          )}
        </p>
        <div className="flex gap-[10px] items-center mt-2">
          <img src={ic_location} className="w-5 h-5" />
          <p className="text-[#606060] font-normal">
            Địa điểm làm việc: Hà nội
          </p>
        </div>
        <div className="flex gap-[10px] items-center mt-2">
          <img src={ic_timer_pause} className="w-5 h-5" />
          <p className="text-[#606060] font-normal">
            Hạn tuyển dụng: {formatDate(item.deadlineTime)}
          </p>
        </div>
      </Box>
    </Link>
  );
}
